<div class="row">
  <div class="col-md-6">
    <app-form-group><label>Type</label><input class="form-control" [(ngModel)]="gas.type" disabled required></app-form-group>
    <app-form-group><label>Id</label><input class="form-control" [(ngModel)]="gas['id']" disabled required></app-form-group>
  </div>
  <div class="col-md-6">
    <app-form-group><label>Name</label><input class="form-control" [(ngModel)]="gas.name" required></app-form-group>
    <app-form-group><label>UN code</label><input class="form-control" [(ngModel)]="gas.unCode"></app-form-group>
    <app-form-group><label>Good code</label><input class="form-control" [(ngModel)]="gas.goodCode"></app-form-group>
  </div>
</div>
